module.exports = __webpack_public_path__ + "static/media/everybrand_icon.be578f0a.svg";